
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-dedicated-agent",
      function () {
        return require("private-next-pages/service-dedicated-agent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-dedicated-agent"])
      });
    }
  